import { useCallback, useState } from 'react';

export const useModalState = (defaultOpen = false) => {
	const [isOpen, setIsOpen] = useState(defaultOpen);
	const onClose = useCallback(() => setIsOpen(false), [setIsOpen]);
	const onOpen = useCallback(() => setIsOpen(true), [setIsOpen]);
	return { isOpen, onClose, onOpen };
};
